@use '@terminal/components/tooltip-container/shared-tooltip-styles' as *;

.tableLoaderWrapper {
  height: 100%;
}

.errorMessageWrapper {
  border: none;
}

.cellWithTooltip {
  &.hasTooltip {
    @include underline-text-styles;
  }
}

.overflowEllipsisTextCell {
  overflow-x: hidden;
  text-overflow: ellipsis;
  padding-bottom: 3px;
  margin-bottom: -3px;
  font-family: var(--font-nort);

  &.hasTooltip {
    @include underline-text-styles;
  }
}


.underlinedTextWrapper {
  @include underline-text-styles;
}

.styledListWrapper {
  padding-left: 20px;
}
